/* Somnair · Batch reservation widget.
   Renders the real recurring shipping-cutoff calendar (days of month from data-smb-cutoffs,
   e.g. 8,18,28): previous cutoff = CLOSED, next cutoff = the batch you're joining, the one
   after = UPCOMING. Dates and the day count are pure calendar maths off the visitor's clock —
   nothing is invented here, and nothing is stored.

   The "% RESERVED" bar is NOT computed here: it is rendered server-side from live Shopify
   inventory, precisely so this script cannot fabricate it. If inventory isn't tracked the
   bar is absent and the label reads "SHIPPING NEXT".

   The widget ships `hidden` and is only revealed once a valid cutoff window is resolved, so a
   JS failure shows nothing rather than blank dates. */
(function () {
  var MONTHS = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
                'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];

  function ordinal(n) {
    var suffix = ['TH', 'ST', 'ND', 'RD'], v = n % 100;
    return n + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]);
  }

  function label(d) {
    return MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate());
  }

  /* Every cutoff from 2 months back to 3 months ahead, sorted. Guards against a day that
     doesn't exist in a given month (e.g. 31 in February) by checking the month didn't roll. */
  function cutoffs(daysOfMonth, today) {
    var list = [];
    for (var m = -2; m <= 3; m++) {
      var base = new Date(today.getFullYear(), today.getMonth() + m, 1);
      for (var i = 0; i < daysOfMonth.length; i++) {
        var dt = new Date(base.getFullYear(), base.getMonth(), daysOfMonth[i]);
        if (dt.getMonth() === base.getMonth()) list.push(dt);
      }
    }
    return list.sort(function (a, b) { return a - b; });
  }

  function init(w) {
    if (w.dataset.smbInit) return;
    w.dataset.smbInit = '1';

    /* Deduplicated: "8,8,18" (or "8,08") would otherwise emit the same date as both the
       batch you're joining and the UPCOMING one. */
    var seen = {};
    var days = (w.getAttribute('data-smb-cutoffs') || '')
      .split(',')
      .map(function (x) { return parseInt(x, 10); })
      .filter(function (x) {
        if (!(x >= 1 && x <= 31) || seen[x]) return false;
        seen[x] = true;
        return true;
      })
      .sort(function (a, b) { return a - b; });
    if (days.length < 1) return;

    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var list = cutoffs(days, today);

    var i = -1;
    for (var k = 0; k < list.length; k++) {
      if (list[k] >= today) { i = k; break; }
    }
    if (i < 1 || i + 1 >= list.length) return; /* need a previous AND a following cutoff */

    var diff = Math.round((list[i] - today) / 86400000);
    var set = function (sel, txt) {
      var els = w.querySelectorAll(sel);   /* fill ALL matches, e.g. the active date reused in the price-revert note */
      for (var q = 0; q < els.length; q++) els[q].textContent = txt;
    };

    set('[data-smb-days]', diff <= 0 ? 'TODAY' : (diff === 1 ? '1 DAY' : diff + ' DAYS'));
    set('[data-smb-prev]', label(list[i - 1]));
    set('[data-smb-active]', label(list[i]));
    set('[data-smb-next]', label(list[i + 1]));

    animate(w);
    w.removeAttribute('hidden');
  }

  /* Grow the fill from 0 to its real width when the widget scrolls into view.
     The target width is the server-rendered --smb-pct and is never touched here — this
     only animates towards it. `data-smb-anim` is what collapses the bar to 0 in CSS, so
     it is set exclusively on the path where we can also add `is-live` to expand it: if
     anything below is unsupported or throws, the bar simply paints at its real width. */
  function animate(w) {
    if (!w.querySelector('.smb__fill')) return;              /* untracked: no bar to grow */
    if (!('IntersectionObserver' in window)) return;
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    } catch (e) { return; }

    w.setAttribute('data-smb-anim', '');                     /* before the unhide: no flash */
    var io = new IntersectionObserver(function (entries) {
      for (var j = 0; j < entries.length; j++) {
        if (entries[j].isIntersecting) {
          w.classList.add('is-live');
          io.disconnect();
          return;
        }
      }
    }, { threshold: 0.35 });
    io.observe(w);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-smb]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Shopify theme-editor re-renders the section without a page load. */
  document.addEventListener('shopify:section:load', boot);
})();
